import axios from "../../config/axiosConfig";
import {
  PURCHASE_ORDER_BALANCE_STOCK_REPORT_REQUEST,
  PURCHASE_ORDER_BALANCE_STOCK_REPORT_SUCCESS,
  PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE,
  PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST,
  PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
  PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE,
  PURCHASE_ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
  SET_PURCHASE_OUTSTANDING_BY_ACCOUNTS,
} from "../types/purchase-order-balance-stock-report-types";

export const getPurchaseOrderBalanceBillBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getPurchaseOrderBalanceBillBaseReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(bill base) Report:", error);
        dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(bill base) Report:", error);
      dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseOrderBalanceStockFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/stock-report/getPurchaseOrderBalanceBillBaseOptions?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('<<purchase-API Response Data: ', response);
                if (response.data) {
                  dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching order balance(bill base) Report:", error);
                dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching order balance(bill base) Report:", error);
            dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearPurchaseOrderBalanceBillBaseStockReportReport = () => {
  return async (dispatch) => {
        dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}

export const closePurchaseOrderWithTransaction = (orderId, transactionId) => {
  return async (dispatch, getState) => {
    try {
      const queryString = new URLSearchParams({ orderId, transactionId }).toString();
      const fullUrl = `/purchase-order/closeOrder?${queryString}`;
      // Make API call
      return axios.put(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          return response;
        }
      }).catch((error) => {
        console.error("Error closing order:", error);
        throw error;
      });
    } catch (error) {
      console.error("Error closing order:", error);
      throw error;
    }
  };
};

export const getPurchaseOutstandingByAccounts = (accountIds) => {
  return async (dispatch, getState) => {
    try {
      const params = { accountIds };

      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `/dashboard/getPayableOutstandingByAccounts?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SET_PURCHASE_OUTSTANDING_BY_ACCOUNTS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(bill base) Report:", error);
        dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(bill base) Report:", error);
      dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseOrderBalanceChallanBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };
      console.log('Request Param Datas >>', requestParams);

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getPurchaseOrderBalanceChallanBaseReport?${queryString}`;

      console.log('>Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(challan base) Report:", error);
        dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(challan base) Report:", error);
      dispatch({ type: PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};
export const clearPurchaseOrderBalanceChallanBaseStockReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}